<template>
  <div
    v-loading="loading"
    class="use-rebate-block"
  >
    <BaseElForm
      ref="formRef"
      label-position="left"
      label-width="100px"
      :model="formData"
      :rules="formRules"
    >
      <BaseElFormItem :label="displayData.formItemlabel.type" prop="type">
        <BaseElRadioGroup v-model="formData.type" @change="onTypeChange">
          <BaseElRadio v-if="showControl.usePoint" label="use">{{ displayData.btn.use }}</BaseElRadio>
          <BaseElRadio v-if="showControl.addPoint" label="add">{{ displayData.btn.give }}</BaseElRadio>
        </BaseElRadioGroup>
      </BaseElFormItem>
      <BaseElFormItem :label="displayData.formItemlabel.amount" prop="amount">
        <BaseElInput v-model="formData.amount" type="number" :placeholder="displayData.placeholder.amount" />
      </BaseElFormItem>
      <BaseElFormItem :label="displayData.formItemlabel.comment" prop="commnet">
        <BaseElInput v-model="formData.comment" :placeholder="displayData.placeholder.comment" />
      </BaseElFormItem>
      <BaseElFormItem>
        <div>
          <BaseElButton @click="onCancel">
            {{ displayData.btn.cancel }}
          </BaseElButton>
          <BaseElButton type="primary" @click="handleRebateWallet">
            {{ displayData.btn.save }}
          </BaseElButton>
        </div>
      </BaseElFormItem>
    </BaseElForm>
  </div>
</template>

<script>
import { reactive, ref, computed, defineComponent, inject } from 'vue'
import { maxNumberRules, minRules, noEmptyRules, rangeRules } from '@/validation'
import { AddPointWalletRecord, UsePointWalletRecord } from '@/api/shopPoint'
import store from '@/store'
import formUtils from '@/utils/form'
import { debounce, get } from 'lodash'
import { usePermissions } from '@/use/permissions'
import notifyMessage from '@/config/notifyMessage'
import { t } from '@/plugins/i18n/i18n'

export default defineComponent({
  name: 'UsePointBlock',
  props: {
    memberId: {
      type: String,
    },
    pointBalance: {
      type: Object,
      default: () => ({}),
    },
    shopPointKey: {
      type: String,
    },
    pointFeatrue: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props, { emit }) {
    const pageShopPoint = inject('pageShopPoint')
    const { checkAction } = usePermissions()

    const loading = ref(false)
    const formRef = ref(null)
    const shopId = computed(() => store.getters.shop)

    // const usePermission = computed(() => {
    //   return checkAction('admin.member.usePointWalletRecord')
    // })
    // const givePermission = computed(() => {
    //   return checkAction('admin.member.addPointWalletRecord')
    // })

    // >> 表單資料
    const formData = reactive({
      type: null,
      amount: null,
      comment: null,
    })

    // ?? 表單驗證規則
    const formRules = computed(() => {
      const rules = {
        type: [noEmptyRules()],
        amount: [noEmptyRules()],
      }
      if (formData.type === 'use') {
        const balance = get(props.pointBalance, `${props.shopPointKey}.balance`, 0)
        if (!balance) {
          rules.amount.push(minRules(0))
          rules.amount.push(maxNumberRules(balance))
        } else {
          rules.amount.push(rangeRules(1, balance))
        }
      } else if (formData.type === 'add') {
        rules.amount.push(minRules(1))
      }
      return rules
    })

    // ?? 頁面顯示資料
    const displayData = computed(() => {
      const data = {
        btn: {
          use: t('member.tab.point.useDeduct'),
          give: t('member.tab.point.givePoint'),
          cancel: t('member.tab.point.cancel'),
          save: t('member.tab.point.save'),
        },
        formItemlabel: {
          type: t('member.tab.point.operation'),
          amount: get(pageShopPoint.value, 'name', t('member.tab.point.defaultName')),
          comment: t('member.tab.point.remark'),
        },
        placeholder: {
          amount: t('member.tab.point.enterAmount'),
          comment: t('member.tab.point.enterRemark'),
        },
      }
      return data
    })

    const onCancel = () => {
      formData.type = null
      formData.amount = null
      formData.comment = null
      setTimeout(() => {
        formUtils.clearValidate(formRef.value)
      }, 30)
    }

    const onTypeChange = () => {
      setTimeout(() => {
        formUtils.clearValidate(formRef.value)
      }, 30)
    }

    const handleRebateWallet = debounce(async () => {
      if (loading.value) return
      loading.value = true
      if (!(await formUtils.checkForm(formRef.value))) {
        loading.value = false
        return
      }
      const type = formData.type
      const methods = {
        add: AddPointWalletRecord,
        use: UsePointWalletRecord,
      }
      const [, err] = await methods[type]({
        shopId: shopId.value,
        memberId: props.memberId,
        originMessage: formData.comment || undefined,
        addAmount: type === 'add' ? formData.amount : undefined,
        useAmount: type === 'use' ? formData.amount : undefined,
        shopPointKey: props.shopPointKey,
      })
      loading.value = false
      if (err) return (window.$message.error(err))
      emit('refresh')
      window.$message.success(notifyMessage.operationSuccess)
      onCancel()
    }, 300, { leading: false, trailing: true })

    const showControl = computed(() => {
      const controls = {
        usePoint: checkAction('admin.member.usePointWalletRecord') &&
                  get(props.pointFeatrue, 'usePointWalletRecord', true),
        addPoint: checkAction('admin.member.addPointWalletRecord') &&
                  get(props.pointFeatrue, 'addPointWalletRecord', true),
      }
      return controls
    })

    return {
      loading,
      displayData,
      formData,
      formRules,
      formRef,
      onCancel,
      handleRebateWallet,
      // usePermission,
      // givePermission,
      pageShopPoint,
      onTypeChange,
      showControl,
    }
  },
})

</script>

<style scoped lang="postcss">

</style>
